/* 商品一覧：検索条件の開閉・価格のかんたんボタン */
(() => {
  const form = document.querySelector('.js-filter-form');
  if (!form) return;
  const toggle = form.querySelector('.js-filter-toggle');
  toggle?.addEventListener('click', () => {
    const open = toggle.getAttribute('aria-expanded') === 'true';
    toggle.setAttribute('aria-expanded', String(!open));
    toggle.setAttribute('aria-label', open ? toggle.dataset.open : toggle.dataset.close);
    form.classList.toggle('is-closed', open);
  });
  const min = form.querySelector('.js-price-min');
  const max = form.querySelector('.js-price-max');
  form.querySelectorAll('.js-price-preset').forEach(b => b.addEventListener('click', () => {
    if (min) min.value = b.dataset.min;
    if (max) max.value = b.dataset.max;
    form.requestSubmit ? form.requestSubmit() : form.submit();
  }));
  // 空の価格欄は送らない（URL をすっきりさせる）
  form.addEventListener('submit', () => {
    [min, max].forEach(i => { if (i && i.value === '') i.disabled = true; });
  });
  // 対象・カテゴリ：1つだけ選べる。選んだコレクションへ（何も選ばないと全商品）
  const kinds = [...form.querySelectorAll('.js-kind')];
  kinds.forEach(k => k.addEventListener('change', () => {
    if (k.checked) kinds.forEach(o => { if (o !== k) o.checked = false; });
    const on = kinds.find(o => o.checked);
    form.action = on ? on.dataset.url : form.dataset.base;
  }));
  // 画面の中で絞る価格（pmin／pmax）は、URL の値を入力欄に戻す
  const qs = new URLSearchParams(location.search);
  ['pmin', 'pmax'].forEach(k => { const i = form.querySelector('input[name="' + k + '"]'); if (i && qs.get(k)) i.value = qs.get(k); });
  // 並び替えは選んだらすぐ反映
  form.querySelector('#SortBy')?.addEventListener('change', () => form.requestSubmit ? form.requestSubmit() : form.submit());
})();

/* 商品一覧：並べ替え（売り切れを最後に・箱やベルトを後ろに）
   data-segs の「区切り」（コレクションの URL × 在庫あり 1／在庫切れ 0）を順につないだ並びから、
   今のページ分（per 点）を、それぞれの区切りで絞り込んだページを読み込んで取り出す */
(() => {
  const grid = document.querySelector('.js-main-grid[data-segs]');
  if (!grid) return;
  const q0 = new URLSearchParams(location.search);
  if (grid.dataset.clientPrice && (q0.get('pmin') || q0.get('pmax'))) { grid.classList.remove('is-sorting'); return; }
  const d = grid.dataset;
  let segs;
  try { segs = JSON.parse(d.segs); } catch (_) { return; }
  const n = +d.per, p = +d.page, total = +d.total;
  const done = () => grid.classList.remove('is-sorting');
  const timer = setTimeout(done, 5000);
  const cache = {};

  // 区切りのページを読み込む（件数と商品カード）。同じページは1回だけ
  const load = (seg, page) => {
    const key = seg.u + '|' + seg.v + '|' + page;
    if (cache[key]) return cache[key];
    const u = new URL(seg.u, location.origin);
    const cur = new URLSearchParams(location.search);
    cur.forEach((val, k) => { if (k !== 'page') u.searchParams.append(k, val); });
    if (seg.v !== undefined) { u.searchParams.delete(d.param); u.searchParams.set(d.param, seg.v); }
    u.searchParams.set('page', page);
    u.searchParams.set('section_id', d.section);
    return cache[key] = fetch(u).then(r => { if (!r.ok) throw new Error(r.status); return r.text(); }).then(t => {
      const doc = new DOMParser().parseFromString(t, 'text/html');
      const c = doc.querySelector('.items-count span');
      return { count: c ? parseInt(c.textContent.replace(/[^0-9]/g, ''), 10) : NaN, items: [...doc.querySelectorAll('.js-main-grid > li')] };
    });
  };
  const count = seg => seg.c !== undefined ? Promise.resolve(seg.c) : load(seg, 1).then(r => r.count);

  Promise.all(segs.map(count)).then(counts => {
    if (counts.some(isNaN) || counts.reduce((a, b) => a + b, 0) !== total) throw new Error('count');
    const start = (p - 1) * n, end = Math.min(p * n, total);
    const jobs = [];
    let off = 0;
    segs.forEach((seg, i) => {
      const a = Math.max(start - off, 0), b = Math.min(end - off, counts[i]);
      if (a < b) {
        const p1 = Math.floor(a / n) + 1, p2 = Math.floor((b - 1) / n) + 1;
        const pages = [];
        for (let q = p1; q <= p2; q++) pages.push(load(seg, q).then(r => r.items));
        jobs.push(Promise.all(pages).then(ls => ls.flat().slice(a - (p1 - 1) * n, b - (p1 - 1) * n)));
      }
      off += counts[i];
    });
    return Promise.all(jobs).then(parts => {
      const items = parts.flat();
      if (items.length !== end - start) return; // 数が合わないときは元の並びのまま
      items.forEach(li => li.classList.add('is-in'));
      grid.replaceChildren(...items);
    });
  }).catch(() => {}).finally(() => { clearTimeout(timer); done(); });
})();

/* 商品一覧：価格で絞る（Shopify の価格の絞り込みはお店の通貨のときだけなので、それ以外は画面の中で絞る）
   同じ条件（並び替え・ブランドなど）の商品カードを 50 点ずつ読み込み（sections/collection-cards）、
   価格で絞ってから、売り切れ・箱ベルトを後ろにして、1ページ分を表示する */
(() => {
  const grid = document.querySelector('.js-main-grid[data-client-price]');
  if (!grid) return;
  const d = grid.dataset;
  const qs = new URLSearchParams(location.search);
  const num = v => (v === null || v === '' || isNaN(+v)) ? null : +v;
  const lo = num(qs.get('pmin')), hi = num(qs.get('pmax'));
  if (lo === null && hi === null) return;
  const sec = grid.closest('.items-sec');
  const pager = sec.querySelector('.pager');
  const count = sec.querySelector('.items-count span');
  grid.classList.add('is-sorting');
  if (pager) pager.hidden = true;
  sec.querySelector('.items-tail')?.remove();

  const load = page => {
    const u = new URL(location.pathname, location.origin);
    qs.forEach((v, k) => { if (!['pmin', 'pmax', 'page'].includes(k)) u.searchParams.append(k, v); });
    u.searchParams.set('section_id', 'collection-cards');
    u.searchParams.set('page', page);
    return fetch(u).then(r => { if (!r.ok) throw new Error(r.status); return r.text(); })
      .then(t => new DOMParser().parseFromString(t, 'text/html').querySelector('.js-cards'));
  };
  load(1).then(first => {
    const pages = +first.dataset.pages || 1;
    const rest = [];
    for (let i = 2; i <= pages; i++) rest.push(load(i));
    return Promise.all(rest).then(ls => [first, ...ls].flatMap(ul => [...ul.children]));
  }).then(all => {
    const yen = li => +li.dataset.p / 100;
    let items = all.filter(li => (lo === null || yen(li) >= lo) && (hi === null || yen(li) <= hi));
    const rank = li => (d.split && li.dataset.acc === '1' ? 2 : 0) + (d.soldLast && li.dataset.av === '0' ? 1 : 0);
    items = items.map((li, i) => [li, i]).sort((a, b) => rank(a[0]) - rank(b[0]) || a[1] - b[1]).map(x => x[0]);
    const per = +d.per2 || 12, total = items.length;
    const pages = Math.max(1, Math.ceil(total / per));
    const cur = Math.min(Math.max(1, +qs.get('page') || 1), pages);
    if (count) count.textContent = total;
    // 条件の表示（価格 × で外せる）
    const cond = sec.querySelector('.items-cond');
    if (cond) {
      const f = n => d.cur + Math.round(n).toLocaleString();
      const off = new URLSearchParams(qs); off.delete('pmin'); off.delete('pmax'); off.delete('page');
      const a = document.createElement('a');
      a.className = 'chip chip--on';
      a.href = location.pathname + (off.toString() ? '?' + off : '');
      a.textContent = (lo !== null ? f(lo) : '') + d.sep + (hi !== null ? f(hi) : '') + ' ×';
      if (!cond.querySelector('.chip')) cond.textContent = d.cond;
      cond.append(a);
    }
    if (total === 0) {
      const p = document.createElement('p');
      p.className = 'items-empty';
      p.textContent = d.empty;
      grid.replaceWith(p);
      return;
    }
    const show = items.slice((cur - 1) * per, cur * per);
    show.forEach(li => li.classList.add('is-in'));
    grid.replaceChildren(...show);
    // ページ送り
    if (pages > 1) {
      const nav = document.createElement('nav');
      nav.className = 'pager';
      const link = n => { const p = new URLSearchParams(qs); p.set('page', n); return location.pathname + '?' + p; };
      const add = (n, text, arrow) => {
        const el = document.createElement(n === cur && !arrow ? 'span' : 'a');
        el.className = 'pager__btn' + (arrow ? ' pager__btn--arrow' : '');
        if (el.tagName === 'A') el.href = link(n); else el.setAttribute('aria-current', 'page');
        if (arrow) { const s = document.createElement('span'); s.className = 'arrow' + (arrow === 'l' ? ' arrow--left' : ''); el.append(s); } else el.textContent = n;
        nav.append(el);
      };
      if (cur > 1) add(cur - 1, '', 'l');
      for (let n = 1; n <= pages; n++) add(n);
      if (cur < pages) add(cur + 1, '', 'r');
      (pager || grid).after(nav);
      if (pager) pager.remove();
    }
  }).catch(() => { if (pager) pager.hidden = false; })
    .finally(() => grid.classList.remove('is-sorting'));
})();

/* 商品一覧：2列／4列の切り替え（選んだ列数はブラウザに記憶） */
(() => {
  const sec = document.querySelector('.js-items-sec');
  if (!sec) return;
  const btns = sec.querySelectorAll('.js-grid-btn');
  const sync = () => {
    const four = sec.classList.contains('is-grid-4');
    btns.forEach(b => b.setAttribute('aria-pressed', String((b.dataset.cols === '4') === four)));
  };
  btns.forEach(b => b.addEventListener('click', () => {
    sec.classList.toggle('is-grid-4', b.dataset.cols === '4');
    try { localStorage.setItem('wt_grid', b.dataset.cols); } catch (_) {}
    sync();
  }));
  sync();
})();
